import React, { useEffect, useRef } from 'react';

const HereMap = ({ apiKey, consignor, consignee }) => {
    const mapRef = useRef(null);

    useEffect(() => {
        if (!window.H || !mapRef.current) return;

        const platform = new window.H.service.Platform({
            'apikey': apiKey
        });

        const defaultLayers = platform.createDefaultLayers();

        const map = new window.H.Map(
            mapRef.current,
            defaultLayers.vector.normal.map,
            {
                pixelRatio: window.devicePixelRatio || 1
            }
        );

        const mapEvents = new window.H.mapevents.MapEvents(map);
        new window.H.mapevents.Behavior(mapEvents);

        const ui = window.H.ui.UI.createDefault(map, defaultLayers);

        const routeAndDisplay = (origin, destination) => {
            const router = platform.getRoutingService(null, 8);

            const routingParameters = {
                'routingMode': 'fast',
                'transportMode': 'car',
                // Origin and destination as comma separated strings "lat,lng"
                'origin': `${origin.lat},${origin.lng}`,
                'destination': `${destination.lat},${destination.lng}`,
                'return': 'polyline'
            };

            router.calculateRoute(routingParameters, (result) => {
                if (result.routes.length) {
                    result.routes[0].sections.forEach((section) => {
                        // Decode the flexible polyline of the section's shape
                        const linestring = window.H.geo.LineString.fromFlexiblePolyline(section.polyline);

                        // Create a polyline to display the route
                        const routeLine = new window.H.map.Polyline(linestring, {
                            style: { strokeColor: 'blue', lineWidth: 3 }
                        });

                        // Add the route polyline to the map
                        map.addObject(routeLine);

                        // Zoom the map to fit the route
                        map.getViewModel().setLookAtData({
                            bounds: routeLine.getBoundingBox()
                        });
                    });
                }
            }, (error) => {
                console.error('Routing request error:', error);
            });
        };

              
        const geocodeAndMark = (addressData) => {
            const address = `${addressData.city}, ${addressData.state}, ${addressData.postcode}`;
            const geocodeUrl = `https://geocode.search.hereapi.com/v1/geocode?q=${encodeURIComponent(address)}&apiKey=${apiKey}`;

            return new Promise((resolve, reject) => {
                fetch(geocodeUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.items && data.items.length > 0) {
                            const location = data.items[0].position;
                            // Create a marker for the geocoded location
                            const marker = new window.H.map.Marker({ lat: location.lat, lng: location.lng });
                            map.addObject(marker);
                            // Resolve the promise with the coordinates
                            resolve({ lat: location.lat, lng: location.lng });
                        } else {
                            reject(new Error('Geocode was not successful.'));
                        }
                    })
                    .catch(error => {
                        reject(new Error('Geocode was not successful for the following reason: ' + error));
                    });
            });
        };



        // Chain the geocoding and routing calls
        Promise.all([
            geocodeAndMark({ city: consignor.consignorCity, state: consignor.consignorState, postcode: consignor.consignorPostcode }),
            geocodeAndMark({ city: consignee.consigneeCity, state: consignee.consigneeState, postcode: consignee.consigneePostcode })
        ]).then(([consignorCoords, consigneeCoords]) => {
            // Once we have both coordinates, we can route and display
            routeAndDisplay(consignorCoords, consigneeCoords);
        }).catch(error => {
            console.error(error.message);
        });

        return () => {
            if (map.dispose) map.dispose();
        };
    }, [apiKey, consignor, consignee]);

    return <div ref={mapRef} style={{ height: '500px' }} />;
};

export default HereMap;
